var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "funko-carousel"
  }, [_c('b-carousel', {
    attrs: {
      "id": "carousel-1",
      "interval": 3000,
      "indicators": "",
      "img-width": "1024",
      "img-height": "480"
    },
    on: {
      "sliding-start": _vm.onSlideStart,
      "sliding-end": _vm.onSlideEnd
    },
    model: {
      value: _vm.slide,
      callback: function callback($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, [_c('b-carousel-slide', {
    staticClass: "funko-carousel__img",
    attrs: {
      "img-src": require("@/assets/img/BANNER4.png")
    }
  }), _c('b-carousel-slide', {
    staticClass: "funko-carousel__img",
    attrs: {
      "img-src": require("@/assets/img/BANNER3.png")
    }
  }), _c('b-carousel-slide', {
    staticClass: "funko-carousel__img",
    attrs: {
      "img-src": require("../assets/img/BANNER1.png")
    }
  }), _c('b-carousel-slide', {
    staticClass: "funko-carousel__img",
    attrs: {
      "img-src": require("../assets/img/BANNER2.png")
    }
  }), _c('b-carousel-slide', {
    staticClass: "funko-carousel__img",
    attrs: {
      "img-src": require("@/assets/img/BANNER5.png")
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }